import overviewCopy from '@/components/overview/item/overviewCopy/index.vue';
import overviewEdit from '@/components/overview/item/overviewEdit/index.vue';
import overviewShare from '@/components/overview/item/overviewShare/index.vue';
import overviewRemove from '@/components/overview/item/overviewRemove/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  components: {
    overviewCopy,
    overviewEdit,
    overviewShare,
    overviewRemove,
  },
  mixins: [
    helpers.general,
  ],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    overviewCopy () {
      return this.checkPermissions('overview', 'overview-copy');
    },
    overviewEdit () {
      return this.checkPermissions('overview', 'overview-edit');
    },
    overviewShare () {
      return this.checkPermissions('overview', 'overview-share');
    },
    overviewRemove () {
      return this.checkPermissions('overview', 'overview-remove');
    },
  },
  methods: {
    /**
         * Show dialog window
         *
         * @param {Number} id
         */
    holderRemoveOverviewGroups (id) {
      this.$modal.show('dialog', {
        title: '<svg class="icon-delete"><use xlink:href="/img/icons/icons-sprite.svg#icon-delete"/></svg>',
        text: '"Do you really want to remove this overview from the list? This action cannor be undone"',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.removeOverviewGroups(id);

            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },

    makeShortName (name) {
      const result = name.length > 35 ? name.slice(0, 30) + '...' : name;
      return result;
    },

    /**
         * Remove overiew group
         *
         * @param {Number} id
         */
    removeOverviewGroups (id) {
      Api.overviews
        .removeGroups(id)
        .then((data) => {
          if (data.data.Status) {
            this.$emit('refresh');

            this.$root.$emit('notification', {
              message: 'Groups was deleted!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
         * Method for restore overview group (Only admin)
         *
         * @param {Integer} id
         */
    restoreDeleted (id) {
      Api.overviews
        .restoreGroups({ 'ID': id })
        .then((response) => {
          if (response.data.Status) {
            this.$emit('refresh');

            this.$root.$emit('notification', {
              message: 'Groups was restored!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },
  },
};
